import React, { createContext, useState } from 'react'
import Wtt from 'Components/ugc/wtt'
import { ImageItem } from 'Components/ugc/imageList'
import { IUser } from 'Components/ugc/user'
import Video from 'Components/ugc/video'
import getLinkHref from 'lib/get-link-href'
import Link from 'next/link'
import Koubei from 'Components/ugc/koubei'
import { IKoubeiInfo } from 'Components/ugc/koubeiInfo'
import QA from 'Components/ugc/qa'
import { IAnswer } from 'Components/ugc/answer'

export interface RawData {
  type: number
  info: {
    behot_time: number
    foleded: boolean
    image_list: ImageItem[]
    digg_count: number
    title: string
    comment_count: number
    user_info: IUser
    user_digg: boolean
    video_id: string
    video_thumb_url: ImageItem[]
    label_tag_list: {
      name: string
      image: ImageItem
      concern_id: number
    }[]
    motor_koubei_info: IKoubeiInfo
    comment_list: IAnswer[]
    question_info: {
      send_award: string
      award_icon_url: string
    }
  }
  unique_id_str: string
  disabled?: boolean
}

export const ArticleCardContext = createContext<any>({
  inheritNewCard: false,
  onReplyClick: undefined,
  group_id: undefined,
  author_id: undefined,
  video_id: undefined,
  type: undefined,
  updated_total_count: undefined,
  updateTotalCount: undefined,
  disabled: false,
})
export const getType = (type: number) => {
  switch (true) {
  case [
    2300,
    2301,
    2302,
    2304,
    2305,
    2306,
    2310,
    2311,
    2312,
    2314,
    2316,
  ].includes(type):
    return 'ugc_article'
  case [2303, 2307, 2313, 2315, 2317].includes(type):
    return 'ugc_video'
  case 2360 <= type && type <= 2369:
    return 'reputation'
  case type === 2318 || (2320 <= type && type <= 2328):
    return 'ugc_qa'
  default:
    return 'other'
  }
}
const ArticleCard = (rawData: RawData) => {
  const { type, info, unique_id_str, disabled } = rawData
  const {
    behot_time,
    image_list,
    digg_count,
    title: content,
    comment_count,
    user_info,
    user_digg,
    video_id,
    video_thumb_url,
    label_tag_list,
    motor_koubei_info,
    comment_list,
    question_info,
  } = info

  const all_info = {
    type,
    image_list,
    user_info,
    content,
    group_id: unique_id_str,
    behot_time,
    comment_count,
    digg_count,
    user_digg,
    video_thumb_url,
    video_id,
    label_tag_list,
    ugcType: -1,
    motor_koubei_info,
    comment_list,
    question_info,
  }
  const [updated_total_count, setTotalCount] = useState(comment_count)
  const updateTotalCount = (count: number) => {
    setTotalCount(count)
  }
  const href = getLinkHref(
    `/ugc/${
      2360 <= type && type <= 2369 ? 'koubei' : 'article'
    }/${unique_id_str}`
  )

  let card
  switch (getType(type)) {
  case 'ugc_article':
    card = <Wtt info={all_info} />
    break
  case 'ugc_video':
    card = <Video info={all_info} />
    break
  case 'reputation':
    card = <Koubei info={all_info} />
    break
  case 'ugc_qa':
    card = <QA info={all_info} />
    break
  default:
    card = <Wtt info={all_info} />
  }
  return (
    <ArticleCardContext.Provider
      value={{
        inheritNewCard: true,
        group_id: unique_id_str,
        author_id: user_info?.user_id,
        video_id,
        type,
        updated_total_count,
        updateTotalCount,
        disabled,
      }}
    >
      <div className="card">
        {disabled ? (
          card
        ) : (
          <a target={'_blank'} href={href}>
            {card}
          </a>
        )}
      </div>

      <style jsx>
        {`
          a:hover {
            color: inherit;
          }
          .card {
            width: 100%;
          }
        `}
      </style>
    </ArticleCardContext.Provider>
  )
}

export default React.memo(ArticleCard)
